/*
 * Cart Drawer Liroma — interactivity
 * Sluit aan op het bestaande <cart-container> custom element (assets/cart.js)
 * voor section rendering + automatische re-render na cart updates.
 */

(function() {
  'use strict';

  const ROOT_SELECTOR = '#offcanvas-cart';

  /* ---------- Helpers ---------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  function getCartContainer() {
    return document.querySelector('cart-container');
  }

  /* ---------- Toast notification ---------- */
  let _toastEl = null;
  function showToast(message, type) {
    if (!_toastEl) {
      _toastEl = document.createElement('div');
      _toastEl.className = 'cdr-toast';
      document.body.appendChild(_toastEl);
    }
    const icon = type === 'error'
      ? '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>'
      : '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
    _toastEl.innerHTML = icon + '<span>' + message + '</span>';
    _toastEl.className = 'cdr-toast is-visible' + (type === 'error' ? ' cdr-toast--error' : ' cdr-toast--success');
    clearTimeout(_toastEl._timer);
    _toastEl._timer = setTimeout(function() {
      _toastEl.classList.remove('is-visible');
    }, 2400);
  }

  /* ---------- Recommendations API loader ---------- */
  async function loadRecommendations(container) {
    const productId = container.getAttribute('data-product-id');
    const limit = container.getAttribute('data-limit') || 4;
    const sectionId = container.getAttribute('data-section-id') || 'cart-drawer-upsell-section';
    if (!productId) return;
    try {
      const url = '/recommendations/products?section_id=' + encodeURIComponent(sectionId)
                + '&product_id=' + encodeURIComponent(productId)
                + '&limit=' + encodeURIComponent(limit)
                + '&intent=related';
      const res = await fetch(url);
      if (!res.ok) throw new Error('Recommendations fetch failed');
      const html = await res.text();
      const tmp = document.createElement('div');
      tmp.innerHTML = html;

      /* Extract cards DIRECTLY — geen wrappers binnen de slider */
      const cards = tmp.querySelectorAll('.cdr-upsell__card');
      container.innerHTML = '';
      cards.forEach(function(card) {
        container.appendChild(card.cloneNode(true));
      });

      /* Verwijder loading state van wrapper */
      const wrapper = container.closest('.cdr-upsell--loading');
      if (wrapper) wrapper.classList.remove('cdr-upsell--loading');
      container.classList.remove('cdr-upsell--loading');

      /* Forceer slider layout op de container */
      forceSliderLayout(container.parentElement || container);

      /* Update slider arrows visibility na recommendations zijn geladen */
      const sliderWrap = container.closest('[data-cdr-slider]');
      if (sliderWrap) {
        sliderWrap._cdrSliderBound = false; // re-bind toestaan
        const root = document.querySelector('#offcanvas-cart');
        if (root) setupSliderArrows(root);
      }
    } catch (err) {
      console.error('Recommendations error:', err);
      const wrap = container.closest('.cdr-upsell');
      if (wrap) wrap.style.display = 'none';
    }
  }

  /* ---------- Discount toggle + form submit ---------- */
  function setupDiscountToggle(root) {
    const toggle = $('[data-cdr-discount-toggle]', root);
    const form = $('[data-cdr-discount-form]', root);
    if (toggle && form && !toggle._cdrBound) {
      toggle._cdrBound = true;
      toggle.addEventListener('click', function(e) {
        e.preventDefault();
        const isOpen = form.classList.toggle('is-open');
        toggle.classList.toggle('is-open', isOpen);
        if (isOpen) {
          const input = form.querySelector('input');
          setTimeout(function() { if (input) input.focus(); }, 200);
        }
      });
    }

    /* Submit handler: pas discount toe + toon success-UI ALTIJD */
    if (form && !form._cdrSubmitBound) {
      form._cdrSubmitBound = true;
      form.addEventListener('submit', async function(e) {
        e.preventDefault();
        const input = form.querySelector('input[name="discount"]');
        const applyBtn = form.querySelector('button[type="submit"]');
        if (!input) return;
        const code = (input.value || '').trim();
        if (!code) {
          input.focus();
          return;
        }

        const originalLabel = applyBtn ? applyBtn.textContent : '';
        if (applyBtn) {
          applyBtn.disabled = true;
          applyBtn.textContent = '...';
        }

        let savedAmount = 0;

        try {
          /* Stap 1: Probeer cart-level discount via undocumented /cart/update.js */
          try {
            const updateRes = await fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ discount: code })
            });
            if (updateRes.ok) {
              const updateData = await updateRes.json();
              savedAmount = updateData.total_discount || 0;
            }
          } catch (e1) { /* niet altijd ondersteund — geen probleem */ }

          /* Stap 2: Zet ook discount cookie via permalink (voor checkout) */
          try {
            await fetch('/discount/' + encodeURIComponent(code), { credentials: 'include' });
          } catch (e2) {}

          /* Stap 3: Sla code op in sessionStorage voor UI-persistentie */
          try {
            sessionStorage.setItem('cdr_applied_code', code);
            sessionStorage.setItem('cdr_applied_amount', String(savedAmount));
          } catch (e3) {}

          /* Stap 4: Full page cart refresh — pakt discount-cookie totalen mee */
          await fullPageCartRefresh();

          /* Stap 5: Re-fetch cart om actueel total_discount te krijgen */
          try {
            const cartRes = await fetch('/cart.js', { credentials: 'include', cache: 'no-store' });
            const cartData = await cartRes.json();
            if (cartData.total_discount && cartData.total_discount > 0) {
              savedAmount = cartData.total_discount;
              try { sessionStorage.setItem('cdr_applied_amount', String(savedAmount)); } catch (e) {}
            }
          } catch (e4) {}

          /* Stap 6: Toon success UI in placeholder */
          renderAppliedDiscountUI(code, savedAmount);
          showToast('Code toegepast', 'success');
          if (applyBtn) {
            applyBtn.disabled = false;
            applyBtn.textContent = originalLabel;
          }
          input.value = '';
        } catch (err) {
          console.error('Discount apply error:', err);
          showToast('Code niet geldig', 'error');
          if (applyBtn) {
            applyBtn.disabled = false;
            applyBtn.textContent = originalLabel;
          }
        }
      });
    }
  }

  /* ---------- Toon success UI in de bestaande Liquid-placeholder ---------- */
  function renderAppliedDiscountUI(code, savedAmount) {
    const block = document.querySelector('#offcanvas-cart [data-cdr-applied-block]');
    const titleEl = document.querySelector('#offcanvas-cart [data-cdr-applied-title]');
    const savingsEl = document.querySelector('#offcanvas-cart [data-cdr-applied-savings]');
    const toggle = document.querySelector('#offcanvas-cart .cdr-discount-toggle');
    const form = document.querySelector('#offcanvas-cart [data-cdr-discount-form]');
    if (!block || !titleEl || !savingsEl) return;

    const titleTpl = (window.__cdr_locale && window.__cdr_locale.applied_title) ||
                     'Code <strong>~~C~~</strong> toegevoegd';
    const savingsTpl = (window.__cdr_locale && window.__cdr_locale.applied_savings) ||
                       'Je bespaart ~~A~~';
    const pendingMsg = (window.__cdr_locale && window.__cdr_locale.applied_pending) ||
                       'Wordt toegepast bij afrekenen';

    titleEl.innerHTML = titleTpl.replace('~~C~~', escapeHtml(code));

    if (savedAmount > 0) {
      const moneyStr = '€' + (savedAmount / 100).toFixed(2).replace('.', ',');
      savingsEl.innerHTML = savingsTpl.replace('~~A~~', escapeHtml(moneyStr));
    } else {
      savingsEl.textContent = pendingMsg;
    }

    block.style.display = '';
    if (toggle) toggle.style.display = 'none';
    if (form) {
      form.style.display = 'none';
      form.classList.remove('is-open');
    }
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function(c) {
      return ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' })[c];
    });
  }

  function hideAppliedDiscountUI() {
    const block = document.querySelector('#offcanvas-cart [data-cdr-applied-block]');
    const toggle = document.querySelector('#offcanvas-cart .cdr-discount-toggle');
    const form = document.querySelector('#offcanvas-cart [data-cdr-discount-form]');
    if (block) block.style.display = 'none';
    if (toggle) toggle.style.display = '';
    if (form) form.style.display = '';
  }

  /* ---------- Restore success UI na cart re-render ---------- */
  function restoreAppliedDiscountUI() {
    /* Probeer eerst van Liquid initial state */
    if (window.__cdr_initial_discount && window.__cdr_initial_discount.code) {
      renderAppliedDiscountUI(
        window.__cdr_initial_discount.code,
        window.__cdr_initial_discount.amount || 0
      );
      return;
    }
    /* Anders uit sessionStorage */
    let code = '';
    let amount = 0;
    try {
      code = sessionStorage.getItem('cdr_applied_code') || '';
      amount = parseInt(sessionStorage.getItem('cdr_applied_amount') || '0', 10);
    } catch (e) {}
    if (code) {
      renderAppliedDiscountUI(code, amount);
    }
  }

  /* ---------- Promo code copy ---------- */
  function setupCodeCopy(root) {
    $$('[data-cdr-copy]', root).forEach(function(btn) {
      btn.addEventListener('click', function() {
        const code = btn.getAttribute('data-cdr-copy');
        const original = btn.getAttribute('data-default') || btn.textContent;
        const copied = btn.getAttribute('data-copied') || 'Copied!';

        const fallback = function() {
          const ta = document.createElement('textarea');
          ta.value = code;
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.select();
          try { document.execCommand('copy'); } catch (err) {}
          document.body.removeChild(ta);
        };

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).catch(fallback);
        } else {
          fallback();
        }

        btn.textContent = copied;
        setTimeout(function() { btn.textContent = original; }, 1500);
      });
    });
  }

  /* ---------- Countdown timer ---------- */
  function setupTimer(root) {
    const el = $('[data-cdr-timer]', root);
    if (!el) return;
    if (el._cdrTimerSet) return;
    el._cdrTimerSet = true;

    const mode = el.getAttribute('data-mode') || 'daily';
    const endStr = el.getAttribute('data-end');
    const durationMin = parseInt(el.getAttribute('data-duration') || '10', 10);

    function getEnd() {
      if (mode === 'duration') {
        /* Persistent in sessionStorage zodat timer doortelt over page navigations.
           Auto-restart: wanneer 0 bereikt, begin opnieuw met dezelfde duur. */
        const key = 'cdr_timer_end_' + durationMin;
        let end = 0;
        try { end = parseInt(sessionStorage.getItem(key) || '0', 10); } catch (e) {}
        if (!end || end <= Date.now()) {
          end = Date.now() + durationMin * 60 * 1000;
          try { sessionStorage.setItem(key, String(end)); } catch (e) {}
        }
        return end;
      }
      if (mode === 'fixed' && endStr) {
        const d = new Date(endStr.replace(/-/g, '/'));
        if (!isNaN(d.getTime())) return d.getTime();
      }
      // Daily mode: tel af naar volgende middernacht (00:00 morgen) — auto-restart elke dag
      const now = new Date();
      return new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0).getTime();
    }

    const dEl = el.querySelector('.cdr-cd-d');
    const hEl = el.querySelector('.cdr-cd-h');
    const mEl = el.querySelector('.cdr-cd-m');
    const sEl = el.querySelector('.cdr-cd-s');

    function tick() {
      const diff = Math.max(0, getEnd() - Date.now());
      // Alleen 'fixed' mode verbergen bij 0 — daily en duration herstarten automatisch
      if (diff <= 0 && mode === 'fixed') {
        el.style.display = 'none';
        return;
      }
      const days = Math.floor(diff / 86400000);
      const hours = Math.floor((diff % 86400000) / 3600000);
      const minutes = Math.floor((diff % 3600000) / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);
      if (dEl) dEl.textContent = String(days).padStart(2, '0');
      if (hEl) hEl.textContent = String(hours).padStart(2, '0');
      if (mEl) mEl.textContent = String(minutes).padStart(2, '0');
      if (sEl) sEl.textContent = String(seconds).padStart(2, '0');
    }

    tick();
    setInterval(tick, 1000);
  }

  /* ---------- AJAX add to cart — event delegation (werkt na re-render) ---------- */
  let _quickAddBound = false;
  function setupQuickAdd(root) {
    if (_quickAddBound) return;
    _quickAddBound = true;

    document.addEventListener('click', async function(e) {
      const btn = e.target.closest('[data-cdr-add]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      if (btn.disabled) return;
      const variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      btn.disabled = true;
      btn.classList.add('is-loading');

      const successMsg = btn.getAttribute('data-success') || 'Toegevoegd!';
      const errorMsg = btn.getAttribute('data-error') || 'Kon niet toevoegen';

      try {
        // Direct AJAX add — geen omweg via cart-container die niet altijd betrouwbaar refresht
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
        });
        if (!res.ok) {
          const err = await res.json().catch(function() { return {}; });
          throw new Error(err.description || 'Add failed');
        }
        showToast(successMsg, 'success');
        // Forceer drawer + badge refresh — werkt altijd
        await refreshCartSection();
      } catch (err) {
        console.error('Cart drawer add error:', err);
        showToast(errorMsg, 'error');
        btn.disabled = false;
        btn.classList.remove('is-loading');
      }
    }, true);
  }

  /* Cart drawer refresh — Shopify Section Rendering API */
  async function refreshCartSection() {
    let sectionOk = false;
    try {
      const url = window.location.pathname + '?sections=offcanvas-cart,cart-count-badge&_=' + Date.now();
      const res = await fetch(url, {
        headers: { 'Accept': 'application/json', 'Cache-Control': 'no-cache' },
        cache: 'no-store',
        credentials: 'include'
      });
      if (res.ok) {
        const data = await res.json();
        if (data && data['offcanvas-cart']) {
          const tmp = new DOMParser().parseFromString(data['offcanvas-cart'], 'text/html');
          const newCart = tmp.querySelector('cart-container');
          const cur = document.querySelector('#offcanvas-cart cart-container');
          if (newCart && cur) {
            cur.innerHTML = newCart.innerHTML;
            sectionOk = true;
          }
        }
        if (data && data['cart-count-badge']) {
          document.querySelectorAll('.cart-count-badge').forEach(function(el) {
            const tmp = new DOMParser().parseFromString(data['cart-count-badge'], 'text/html');
            const newBadge = tmp.querySelector('.cart-count-badge');
            if (newBadge) el.replaceWith(newBadge);
          });
        }
      }
    } catch (err) {
      console.error('Section refresh failed', err);
    }

    // Fallback: als section rendering om wat voor reden niet werkt — full page refresh
    if (!sectionOk) {
      await fullPageCartRefresh();
      return;
    }

    init(); // re-bind events
    // Notify rest van theme dat cart geupdatet is (bv. cart-count badges elders)
    try { window.dispatchEvent(new CustomEvent('kt.cart.reloaded')); } catch (e) {}
  }

  /* Full page-render cart refresh — nodig voor discount cookie totals */
  async function fullPageCartRefresh() {
    try {
      const url = window.location.pathname + '?_=' + Date.now();
      const res = await fetch(url, {
        cache: 'no-store',
        credentials: 'include',
        headers: { 'Cache-Control': 'no-cache, no-store, must-revalidate', 'Pragma': 'no-cache' }
      });
      if (!res.ok) return;
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      /* Cart drawer */
      const newContainer = doc.querySelector('#offcanvas-cart cart-container');
      const curContainer = document.querySelector('#offcanvas-cart cart-container');
      if (newContainer && curContainer) {
        curContainer.innerHTML = newContainer.innerHTML;
      }
      /* Cart count badge(s) */
      const newBadges = doc.querySelectorAll('.cart-count-badge');
      const curBadges = document.querySelectorAll('.cart-count-badge');
      if (newBadges.length && newBadges.length === curBadges.length) {
        curBadges.forEach(function(el, i) {
          el.replaceWith(newBadges[i].cloneNode(true));
        });
      }
      init();
    } catch (err) {
      console.error('Full refresh failed', err);
    }
  }

  /* ---------- Item quantity update + remove ---------- */
  function setupItemControls(root) {
    $$('.cdr-qty', root).forEach(function(qtyEl) {
      if (qtyEl._cdrBound) return;
      qtyEl._cdrBound = true;
      const lineKey = qtyEl.getAttribute('data-line-key');
      if (!lineKey) return;

      const minusBtn = qtyEl.querySelector('[data-cdr-qty-minus]');
      const plusBtn = qtyEl.querySelector('[data-cdr-qty-plus]');
      const valueEl = qtyEl.querySelector('.cdr-qty__value');

      async function updateQty(newQty) {
        if (newQty < 0) return;
        // Direct AJAX change + manual refresh — voorkom dat drawer stale blijft
        try {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: lineKey, quantity: newQty })
          });
        } catch (e) {}
        await refreshCartSection();
      }

      if (minusBtn) {
        minusBtn.addEventListener('click', function() {
          const current = parseInt(valueEl.textContent, 10) || 1;
          updateQty(current - 1);
        });
      }
      if (plusBtn) {
        plusBtn.addEventListener('click', function() {
          const current = parseInt(valueEl.textContent, 10) || 1;
          updateQty(current + 1);
        });
      }
    });

    $$('[data-cdr-remove]', root).forEach(function(btn) {
      if (btn._cdrBound) return;
      btn._cdrBound = true;
      btn.addEventListener('click', async function(e) {
        e.preventDefault();
        const lineKey = btn.getAttribute('data-line-key');
        if (!lineKey) return;
        btn.disabled = true;
        // Optisch verbergen totdat refresh komt
        const itemEl = btn.closest('.cdr-item');
        if (itemEl) itemEl.style.opacity = '0.4';
        try {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: lineKey, quantity: 0 })
          });
        } catch (e) {}
        await refreshCartSection();
      });
    });
  }

  /* ---------- Recommendations placeholders ---------- */
  function setupRecommendations(root) {
    $$('[data-cdr-recommendations]', root).forEach(function(container) {
      if (container._cdrLoaded) return;
      container._cdrLoaded = true;
      loadRecommendations(container);
    });
  }

  /* ---------- Slider arrows (prev/next navigatie) ---------- */
  function setupSliderArrows(root) {
    $$('[data-cdr-slider]', root).forEach(function(wrap) {
      if (wrap._cdrSliderBound) return;
      wrap._cdrSliderBound = true;
      const row = wrap.querySelector('.cdr-upsell__row');
      const prev = wrap.querySelector('[data-cdr-slider-prev]');
      const next = wrap.querySelector('[data-cdr-slider-next]');
      if (!row || !prev || !next) return;

      function getStep() {
        const card = row.querySelector('.cdr-upsell__card');
        if (!card) return 138;
        const styles = window.getComputedStyle(row);
        const gap = parseInt(styles.gap || '8', 10);
        return card.offsetWidth + gap;
      }

      function updateVisibility() {
        const max = row.scrollWidth - row.clientWidth - 1;
        prev.classList.toggle('is-hidden', row.scrollLeft <= 1);
        next.classList.toggle('is-hidden', row.scrollLeft >= max);
        /* Verberg beide als er niets te scrollen valt */
        if (row.scrollWidth <= row.clientWidth + 2) {
          prev.classList.add('is-hidden');
          next.classList.add('is-hidden');
        }
      }

      prev.addEventListener('click', function() {
        row.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });
      next.addEventListener('click', function() {
        row.scrollBy({ left: getStep(), behavior: 'smooth' });
      });
      row.addEventListener('scroll', updateVisibility, { passive: true });
      window.addEventListener('resize', updateVisibility);
      /* Eerste check + nogmaals na 200ms voor zekerheid (na image load) */
      updateVisibility();
      setTimeout(updateVisibility, 200);
      setTimeout(updateVisibility, 600);
    });
  }

  /* ---------- Force slider layout via inline styles ---------- */
  function forceSliderLayout(root) {
    root.querySelectorAll('.cdr-upsell__row').forEach(function(row) {

      /* STAP 1: Vlak trekken — verplaats cards uit wrapper-divs naar direct child van row */
      const allCards = row.querySelectorAll('.cdr-upsell__card');
      allCards.forEach(function(card) {
        if (card.parentElement !== row) {
          row.appendChild(card);
        }
      });
      /* Verwijder lege wrappers die geen cards meer bevatten */
      Array.from(row.children).forEach(function(child) {
        if (!child.classList.contains('cdr-upsell__card') &&
            !child.classList.contains('cdr-skeleton-card') &&
            !child.querySelector('.cdr-upsell__card')) {
          child.remove();
        }
      });

      /* STAP 2: Forceer flex slider via inline styles */
      row.style.display = 'flex';
      row.style.flexDirection = 'row';
      row.style.flexWrap = 'nowrap';
      row.style.overflowX = 'auto';
      row.style.overflowY = 'hidden';
      row.style.width = '100%';

      /* STAP 3: Forceer card-afmetingen */
      row.querySelectorAll('.cdr-upsell__card').forEach(function(card) {
        card.style.flex = '0 0 130px';
        card.style.width = '130px';
        card.style.minWidth = '130px';
        card.style.maxWidth = '130px';
        card.style.pointerEvents = 'auto';
      });

      /* STAP 4: Knoppen klikbaar */
      row.querySelectorAll('.cdr-upsell__add, [data-cdr-add]').forEach(function(btn) {
        btn.style.pointerEvents = 'auto';
        btn.style.cursor = 'pointer';
        btn.style.position = 'relative';
        btn.style.zIndex = '2';
      });
    });
  }

  /* ---------- Discount remove ---------- */
  let _discountRemoveBound = false;
  function setupDiscountRemove(root) {
    if (_discountRemoveBound) return;
    _discountRemoveBound = true;
    document.addEventListener('click', async function(e) {
      const btn = e.target.closest('[data-cdr-discount-remove]');
      if (!btn) return;
      e.preventDefault();
      btn.disabled = true;

      /* Clear sessionStorage state */
      try {
        sessionStorage.removeItem('cdr_applied_code');
        sessionStorage.removeItem('cdr_applied_amount');
      } catch (e0) {}

      try {
        /* Probeer cart-level discount te verwijderen */
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: '' })
        }).catch(function() {});
        /* Clear discount cookie */
        await fetch('/discount/clear', { credentials: 'include' }).catch(function() {});

        /* Verberg success block + toon toggle direct */
        hideAppliedDiscountUI();
        if (window.__cdr_initial_discount) window.__cdr_initial_discount = null;

        /* Full page refresh voor correcte totalen */
        await fullPageCartRefresh();
        /* Re-hide na re-render (init kan het opnieuw tonen vanuit __cdr_initial_discount) */
        hideAppliedDiscountUI();
      } catch (err) {
        console.error('Discount remove error:', err);
        btn.disabled = false;
      }
    }, true);
  }

  /* ---------- Init / re-bind ---------- */
  function init() {
    const root = document.querySelector(ROOT_SELECTOR);
    if (!root) return;
    forceSliderLayout(root);
    setupDiscountToggle(root);
    setupDiscountRemove(root);
    setupCodeCopy(root);
    setupTimer(root);
    setupQuickAdd(root);
    setupItemControls(root);
    setupRecommendations(root);
    setupSliderArrows(root);
    restoreAppliedDiscountUI();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-bind na cart re-render door theme's <cart-container> */
  window.addEventListener('kt.cart.added', function() { setTimeout(init, 50); });
  window.addEventListener('kt.cart.changed', function() { setTimeout(init, 50); });
  window.addEventListener('kt.cart.reloaded', function() { setTimeout(init, 50); });

})();
